var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"layout-container flex-center layout-backtop"},[_c('Headers'),_c('mb-menu'),_c('Mains'),(_vm.isNotCase)?_c('el-backtop',{key:new Date().getTime(),attrs:{"target":".layout-backtop .el-main .el-scrollbar__wrap"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }